import { type FormEvent, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { api, messageOf } from "../lib/api.ts";
import { useAuth, useToken } from "../lib/auth.tsx";

export function Shell() {
  const { me, session, signOut, refreshMe } = useAuth();
  const token = useToken();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(me?.tenant?.name ?? "");
  const [error, setError] = useState("");

  async function rename(event: FormEvent) {
    event.preventDefault();
    setError("");
    try {
      await api("/v1/tenants", token, { method: "PATCH", json: { name: name.trim() } });
      await refreshMe();
      setEditing(false);
    } catch (caught) {
      setError(messageOf(caught));
    }
  }

  return (
    <div className="shell">
      <aside>
        <NavLink to="/app" className="mark" end>
          Bubble
        </NavLink>
        {editing ? (
          <form className="rename" onSubmit={rename}>
            <label>
              Business name
              <input required minLength={2} maxLength={120} value={name} onChange={(event) => setName(event.target.value)} />
            </label>
            {error ? <p className="banner bad">{error}</p> : null}
            <button className="button" type="submit">
              Save
            </button>
          </form>
        ) : (
          <button
            className="business name-button"
            type="button"
            aria-label="Rename business"
            onClick={() => {
              setName(me?.tenant?.name ?? "");
              setEditing(true);
            }}
            disabled={!me?.tenant}
          >
            {me?.tenant?.name ?? "Your business"}
          </button>
        )}
        <p className="email">{me?.user.email ?? session?.user.email}</p>
        <nav>
          <NavLink to="/app" end>
            Home
          </NavLink>
        </nav>
        <button className="text-button" type="button" onClick={() => void signOut()}>
          Sign out
        </button>
      </aside>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
